module.exports = "/images/vendor/flag-icon-css/flags/1x1/kp.svg?f08daf335790f99ff297feab4ed1dcec";